export { MenuAlt1 as default } from './MenuAlt1';
